import { db } from '@/data/firebase/config';
import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import {
  CollectionBase,
  CriticalStandard,
  Newsletter,
  Podcast,
  Report,
  Video,
} from '@/domain/types/collections';
import FormAddDocument from '@/presentation/components/form-add-document';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const VideoAddPage = () => {
  const navigate = useNavigate();

  const handleSave = async (
    data:
      | CollectionBase
      | Video
      | Newsletter
      | Report
      | CriticalStandard
      | Podcast,
  ) => {
    try {
      await addDoc(collection(db, DOCUMENTS_DB.VIDEOS), {
        ...data,
        createdAt: serverTimestamp(),
      });
      toast.success('Video guardado correctamente', {
        theme: 'colored',
      });
      navigate('/dashboard/videos');
    } catch (error) {
      toast.error('Error al guardar el video', {
        theme: 'colored',
      });
      // Re-thrown so FormAddDocument knows the save failed and keeps the
      // autosaved draft instead of deleting the user's only remaining copy.
      throw error;
    }
  };

  return (
    <div className="p-4 flex flex-col gap-4 ">
      <h1 className="text-3xl font-bold">Agregar Video</h1>
      <FormAddDocument
        onSave={handleSave}
        hasAudio={false}
        hasImage={false}
        hasPdf={false}
        hasVideo={true}
        contentType="video"
      />
    </div>
  );
};

export default VideoAddPage;
